export default {
    SAVE_PARAMS: 'HOMEPAGE/SAVE_PARAMS',
    SAVE_SEARCHPARAMS: 'HOMEPAGE/SAVE_SEARCHPARAMS',
}


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/store/constants.js